const defaultLocale = "en"

const i18nPath = {
  it: {
    category: "categoria",
    search: "cerca",
    products: "prodotti",
    type: "tipologie",
    sector: "settore",
    line: "serie",
    careers: "lavora-con-noi",
    contact: "contatti",
  },
  en: {
    category: "category",
    search: "search",
    products: "products",
    type: "type",
    sector: "sector",
    line: "line",
    careers: "work-with-us",
    contact: "contact",
  },
  de: {
    category: "kategorie",
    search: "suche",
    products: "produkte",
    type: "typ",
    sector: "sektor",
    line: "zeile",
    careers: "arbeiten-sie-mit-uns",
    contact: "kontakt",
  },
  "zh-CN": {
    category: "category",
    search: "search",
    products: "products",
    type: "type",
    sector: "sector",
    line: "line",
    careers: "work-with-us",
    contact: "contact",
  },
}

export function getPagePath(page, locale) {
  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale ? "/" : `/${pageLocale.toLowerCase()}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale).value}`
  if (page.root) {
    return lang + `${path}/`
  }

  path = `${
    page.treeParent._allSlugLocales.find(x => x.locale === pageLocale).value
  }/${path}`
  if (page.treeParent.root) {
    return lang + `${path}/`
  }
  path = `${
    page.treeParent.treeParent._allSlugLocales.find(
      x => x.locale === pageLocale
    ).value
  }${path}`
  return lang + `${path}/`
}

export function getHomePath(locale) {
  return locale === defaultLocale ? "/" : `/${locale.toLowerCase()}/`
}

export function getCareerPath(slug, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].careers}/${slug}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].careers}/${slug}/`
}

export function getProductTypePath(page, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].type}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].type}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getSectorPath(page, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].sector}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].sector}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getCareerHomePath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].careers}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].careers}/`
}

export function getSearchPath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].search}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].search}/`
}

export function getContactPath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].contact}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].contact}/`
}

export function getBlogPath(locale) {
  return locale === defaultLocale ? `/blog/` : `/${locale.toLowerCase()}/blog/`
}

export function getLinePagePath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].line}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].line}/`
}

export function getArticleCategoryPath(page, locale) {
  return locale === defaultLocale
    ? `/blog/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/blog/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getCategoryPath(page, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[page.locale].category}/${page.slug}/`
    : `/${page.locale}/${i18nPath[page.locale].category}/${page.slug}/`
}

export function getLinePath(page, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].line}/${
        page._allSlugLocales
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : page.slug
      }/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].line}/${
        page._allSlugLocales
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : page.slug
      }/`
}

export function getArticlePath(page, locale) {
  return locale === defaultLocale
    ? `/blog/${page._allSlugLocales.find(x => x.locale === locale).value}`
    : `/${locale.toLowerCase()}/blog/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getProductPath(page, locale) {
  const slugLocale = page._allSlugLocales.find(
    x => x.locale.replace("_", "-") === locale
  )
  // console.log(slugLocale === undefined ? page : null)
  return locale === defaultLocale
    ? `/${i18nPath[locale].products}/${slugLocale.value || page.slug}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].products}/${
        slugLocale !== undefined ? slugLocale.value : page.slug
      }/`
}

export function getProductsPath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].products}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].products}`
}
